import * as GetJuridicalPersonTypes from 'src/actions/juridical-person/get/Types';
import {
  GetJuridicalPersonAction,
  GetJuridicalPersonSuccess
} from 'src/actions/juridical-person/get/GetJuridicalPerson.actions';
import JuridicalPerson from 'src/entities/JuridicalPerson';

export interface GetJuridicalPersonState {
  juridicalPerson?: JuridicalPerson;
  loading: boolean;
  error: boolean;
  errorMessage: {};
}

const initialState: GetJuridicalPersonState = {
  loading: false,
  error: false,
  errorMessage: {}
};

export function GetJuridicalPersonReducer(
  state: GetJuridicalPersonState = initialState,
  action: GetJuridicalPersonAction
): GetJuridicalPersonState {

  switch (action.type) {
    case GetJuridicalPersonTypes.GET_JURIDICAL_PERSON_ATTEMPT:
      return {...state, juridicalPerson: undefined, loading: true, error: false};
    case GetJuridicalPersonTypes.GET_JURIDICAL_PERSON_SUCCESS:
      const juridicalPerson: JuridicalPerson = (action as GetJuridicalPersonSuccess).payload;
      return {
        ...state,
        juridicalPerson: juridicalPerson,
        loading: false,
        error: false
      };
    case GetJuridicalPersonTypes.GET_JURIDICAL_PERSON_FAILURE:
      return {...state, juridicalPerson: undefined,  loading: false, error: true};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/juridical-person/GetJuridicalPersonReducer.tsx